// Runtime configuration for production deployments
class RuntimeConfig {
  constructor() {
    this.config = null;
    this.initialized = false;
  }

  async initialize() {
    if (this.initialized) {
      return this.config;
    }

    try {
      // Try to load runtime config from a config endpoint
      console.log('RuntimeConfig - Attempting to fetch /config.json');
      const response = await fetch('/config.json');
      if (response.ok) {
        this.config = await response.json();
        console.log('RuntimeConfig - Loaded config.json:', this.config);
      } else {
        console.warn('RuntimeConfig - config.json fetch failed:', response.status);
      }
    } catch (error) {
      console.warn('Could not load runtime config, using defaults:', error);
    }

    // Fallback configuration
    if (!this.config) {
      this.config = this.getDefaultConfig();
      console.log('RuntimeConfig - Using default config:', this.config);
    }

    this.initialized = true;
    console.log('RuntimeConfig - Initialization complete, final config:', this.config);
    return this.config;
  }

  getDefaultConfig() {
    // Auto-detect backend URL based on current environment
    const hostname = window.location.hostname;
    
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      // Local development
      return {
        API_BASE_URL: 'http://localhost:8000/api/v1',
        ENVIRONMENT: 'development'
      };
    } else if (hostname.includes('run.app')) {
      // Google Cloud Run - try to guess backend URL
      const frontendUrl = window.location.origin;
      let backendUrl;
      
      if (frontendUrl.includes('faith-citadel-homecoming-frontend')) {
        backendUrl = frontendUrl.replace('faith-citadel-homecoming-frontend', 'faith-citadel-homecoming-backend');
      } else if (frontendUrl.includes('healthwise-frontend')) {
        backendUrl = frontendUrl.replace('healthwise-frontend', 'healthwise-backend');
      } else {
        // Fallback: assume backend is on same domain with /api prefix
        backendUrl = frontendUrl;
      }
      
      return {
        API_BASE_URL: `${backendUrl}/api/v1`,
        ENVIRONMENT: 'production'
      };
    } else {
      // Custom domain or other hosting
      return {
        API_BASE_URL: `${window.location.origin}/api/v1`,
        ENVIRONMENT: 'production'
      };
    }
  }

  getApiBaseUrl() {
    if (!this.initialized) {
      console.warn('RuntimeConfig not initialized, using fallback');
      const fallback = this.getDefaultConfig().API_BASE_URL;
      console.log('RuntimeConfig fallback URL:', fallback);
      return fallback;
    }
    
    console.log('RuntimeConfig initialized, returning:', this.config.API_BASE_URL);
    return this.config.API_BASE_URL;
  }
}

export const runtimeConfig = new RuntimeConfig();

// Initialize immediately
runtimeConfig.initialize().catch(console.error);
